import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Pause20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_889)'>
      <path d='M11.25 14.5V5.5H12.75V14.5H11.25Z' fill='currentColor' />
      <path d='M7.25 5.5V14.5H8.75V5.5H7.25Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 9.99997C0.25 4.61519 4.61522 0.249969 10 0.249969C15.3848 0.249969 19.75 4.61519 19.75 9.99997C19.75 15.3847 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3847 0.25 9.99997ZM10 1.74997C5.44365 1.74997 1.75 5.44362 1.75 9.99997C1.75 14.5563 5.44365 18.25 10 18.25C14.5563 18.25 18.25 14.5563 18.25 9.99997C18.25 5.44362 14.5563 1.74997 10 1.74997Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_889'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Pause20.displayName = 'Pause20';
export default Pause20;
